export function splitCamelCase(str: string) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, c => c.toUpperCase());
}